import {
  ColorsV2,
  Flex,
  Icon,
  IconNames,
  Skeleton,
  Text,
  useThemeColors,
  spaces,
} from '@electricjs/arc';

type NotificationDetailProps = {
  icon: IconNames;
  value?: string;
  loading: boolean;
};

export const NotificationDetail = ({
  icon,
  value,
  loading,
}: NotificationDetailProps) => {
  const [textColor] = useThemeColors([ColorsV2.GRAY_DARK]);

  if (loading) {
    return <Skeleton></Skeleton>;
  }

  return (
    <Flex my={spaces.space_2xs} gap={spaces.space_2xs}>
      <Icon icon={icon} size="small" color={textColor} />
      <Text variant="body-2" color={textColor}>
        {value}
      </Text>
    </Flex>
  );
};
